import { OnboardingVerificationRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/onboarding/verification')({
  component: OnboardingVerificationRoute,
});
